// Gegenereerd door apps/web/scripts/dark-art.mjs: niet met de hand bewerken. Illustraties met een
// donkere variant in public/art-dark/illus (gebruikt door darkArtSwap.ts).
export const DARK_ART_IDS: ReadonlySet<string> = new Set([
  'all-done',
  'birthday',
  'calendar-link',
  'cleaning',
  'cooking',
  'diya',
  'empty-day',
  'family-link',
  'family-table',
  'groceries',
  'growth',
  'holiday',
  'invite',
  'kid-lock',
  'menu',
  'messages',
  'no-tasks',
  'offline',
  'oops',
  'pair-tablet',
  'phagwa',
  'rewards',
  'rooms',
  'school',
  'weather',
  'welcome',
  'wishes',
]);
